import PropTypes from 'prop-types';
import React from 'react';
import { checkValueInStore } from '../../../../AdditionalReportFilters/helpers';
import CheckboxesList from '../../../../FormComponents/CheckboxesList/CheckboxesList';
import InputField from '../../../../FormComponents/InputField/InputField';
import STSComponent from "../../../../STSComponent/STSComponent";
import { clientConstants } from '../../../constants';

class ContactExpandedBlock extends STSComponent {
  returnInputs =(data) => {
    const { updateData, itemData, trackData } = this.props
    return data.map((item, i) => {
      const location = { id: itemData.ClientContactId, field: 'clientContacts' }
      switch (item.type) {
        case 'input':
          return (
            <div key={i} className="input-user-row">
              <div>{item.title}</div>
              <InputField
                type="text"
                location={location}
                id={item.fieldName}
                value={checkValueInStore(item.fieldName, itemData[item.fieldName], trackData[itemData.ClientContactId])}
                updateData={updateData}
              />
            </div>
          )
        case 'checkbox': {
          return <CheckboxesList
            key={i}
            location={location}
            fieldData={[{
              id: item.fieldName,
              text: item.title,
              type: 'checkbox'
            }]}
            values={trackData[itemData.ClientContactId]}
            updateData={updateData}
          />
        }
      }
    })
  }

  render () {
    const { itemData, modal } = this.props
    const className = modal ? 'expanded-contacts' : 'expanded-contacts d-none'
    return (
      <div className={className} data-info={itemData.ClientContactId} key={itemData.ClientContactId}>
        <div className="expanded-title">
          {this.returnInputs(clientConstants.inputsContact)}
        </div>
        <div className="expanded-cbx">
          {this.returnInputs(clientConstants.checkboxesContacts)}
        </div>
      </div>
    )
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    itemData: PropTypes.object,
    modal: PropTypes.bool
  }
}

export default ContactExpandedBlock



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ClientContacts/components/ContactExpandedBlock.js